import React, { useEffect, useState } from 'react';
import { IMapInfo } from '../../../services/cayuga/types';
import ZoomComponent from '../ZoomComponent';
import { ApplicationState } from '../../../store';
import { LayoutState } from '../../../store/layouts/types';
import { useSelector, useDispatch } from 'react-redux';
import MapElementComponent from '../MapElementComponent';
import { getLayoutInfo, setCurrentLayoutChanged } from '../../../store/layouts/actions';
import { CamerasState } from '../../../store/cameras/types';
import './styles.scss';
import { setCurrentCamera } from '../../../store/cameras/actions';
import { bwsAddTimeStrips } from '../../../store/browse/actions';
import { APIState } from '../../../store/API/types';
import SpinnerComponent from '../SpinnerComponent';

interface IProps {
  mapId: string,
  pane: number,
  onImgLoad?: () => void,
  onImgError?: () => void
}

// TODO
// useHistory to make ability move between maps entities

const MapComponent: React.FC<IProps> = ({mapId, pane, onImgLoad, onImgError}) => {
  const {checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {currentCameras} = useSelector<ApplicationState, CamerasState>(state => state.cameras);
  const {cameras} = useSelector<ApplicationState, APIState>(state => state.API);
  const [mapElementsList, setMapElementsList] = useState<JSX.Element[]>([]);
  const [mapBgImg, setMapBgImg] = useState('');
  const [imgState, setImageState] = useState<'fetch' | 'error' | 'success'>('fetch');
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentCameras) {
      dispatch(getLayoutInfo(mapId, 'Map', Object.values(currentCameras).filter(el => (el && (mapId === el.id)))[0]?.name));
    }
  }, []);
  useEffect(() => {
    if (currentCameras[pane]?.subentities?.['a:GeneralEntityInfo']?.['a:MapElementInfo']) {
      const mapElements = currentCameras[pane].subentities['a:GeneralEntityInfo']['a:MapElementInfo'];
      const getMapElements = (elements: any) => {
        if (Array.isArray(elements)) {
          return elements.map((el: any) => <MapElementComponent
              key={el['a:EntityID']}
              element={el}
              onLayerSelect={onLayerSelect}
              onCameraSelect={onCameraSelect}
              onMapSelect={onMapSelect}
              onWebPageSelect={onWebPageSelect}
              onTriggerSelect={onTriggerSelect}
            />
          );
        } else {
          return [
            <MapElementComponent
              key={elements['a:EntityID']}
              element={elements}
              onLayerSelect={onLayerSelect}
              onCameraSelect={onCameraSelect}
              onMapSelect={onMapSelect}
              onWebPageSelect={onWebPageSelect}
              onTriggerSelect={onTriggerSelect}
            />
          ]
        }
      }
      setMapElementsList(getMapElements(mapElements));
    }
    if (currentCameras[pane]?.bgImg) {
      setMapBgImg(`data:image/png;base64,${currentCameras[pane].bgImg}`);
    }
  }, [currentCameras]);

  const onLayerSelect = (el: IMapInfo) => {
    dispatch(getLayoutInfo(el['a:EntityID'], el["a:EntityType"], el["a:Label"]));
  }
  const onCameraSelect = (el: IMapInfo) => {
    const checkedCamera = cameras.filter((camera: any) => camera.id === el["a:EntityID"])[0];
    dispatch({type: 'cancelDeviceStatus'});
    dispatch(setCurrentCamera(checkedCamera ? checkedCamera : null, pane));
    dispatch(bwsAddTimeStrips(pane, [], null));
    dispatch(setCurrentLayoutChanged());
  }
  const onMapSelect = (el: IMapInfo) => {
    dispatch(getLayoutInfo(el["a:EntityID"], 'Map', currentCameras[pane].name, true));
  }
  const onWebPageSelect = (el: IMapInfo) => {
    dispatch(getLayoutInfo(el["a:EntityID"], 'WebPage', currentCameras[pane].name, true));
  }
  const onTriggerSelect = (el: IMapInfo) => {
    dispatch({type: 'globalTrigger', triggerId: el["a:EntityID"]});
  }

  useEffect(() => {
    if (imgState === 'error') {
      setImageState('fetch');
    }
  }, [imgState]);

  const onLoad = () => {
    onImgLoad && onImgLoad();
    setImageState('success');
  }
  const onError = () => {
    onImgError && onImgError();
    setImageState('error');
  }

  return (
    <div className="pos-rel flex js-c al-it-c w-100 h-100 img-center">
      <div className='flex js-c al-it-c o-hidden pos-abs'>
        {imgState === 'fetch' && <SpinnerComponent/>}
      </div>

      {
        (imgState === 'fetch' || imgState === 'success')
        && <ZoomComponent enable={checkedPane === pane}
                          pane={pane}
        >
          <div className="img-wrapper pos-rel">
            <img src={`${mapBgImg}`}
                 onLoad={onLoad}
                 onError={onError}
                 className="map-img"
                 alt="Map Element"
            />
            {mapElementsList}
          </div>
        </ZoomComponent>
      }
    </div>
  )
};


export default MapComponent;